import img from '../../Assets/LearningPath/data-analysis.png'
const DataAnalysisinput = [
    {
        key : 1,
        img : img,
        title : "Data Analysis & Visualization In PBI",
        btn : "Watch Videos",
        link : "/learning-path/accounting&finance/data-analysis&visualization-in-power-bi/",
    },
    {
        key : 2,
        img : img,
        title : "Advance Financial Reporting In Power BI",
        btn : "Watch Videos",
        link : "/learning-path/accounting&finance/advanced-financial-reporting-in-power-bi/videos",
    },
    {
        key : 3,
        img : img,
        title : "Financial Planning & Analysis In Excel & PBI",
        btn : "Watch Videos",
        link : "/learning-path/accounting&finance/",
    },
   
]
export default DataAnalysisinput;